import React, { useState, useEffect } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { heroCarouselImages } from '../mock';
import { ArrowRight, Play } from 'lucide-react';

const Hero = () => {
  const { t } = useLanguage();
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prev) => (prev + 1) % heroCarouselImages.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  const scrollToPilot = () => {
    document.getElementById('pilot')?.scrollIntoView({ behavior: 'smooth' });
  };

  const scrollToSolutions = () => {
    document.getElementById('solutions')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative min-h-[90vh] flex items-center medical-section-bg" style={{ backgroundImage: `url(https://images.unsplash.com/photo-1629410484397-a4dcd74088a0)` }}>
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="space-y-6 fade-in">
            <h1 className="text-5xl lg:text-6xl font-bold leading-tight" style={{ color: '#1A1A1A' }}>
              {t.hero.title}{' '}
              <span style={{ color: '#2D4A8F' }}>{t.hero.titleHighlight}</span>
            </h1>
            
            <div className="flex items-center space-x-6 text-lg font-medium" style={{ color: '#2D4A8F' }}>
              {t.hero.benefits.map((benefit, idx) => (
                <React.Fragment key={idx}>
                  <span>{benefit}</span>
                  {idx < t.hero.benefits.length - 1 && <span>•</span>}
                </React.Fragment>
              ))}
            </div>

            <p className="text-lg text-gray-700 leading-relaxed">
              {t.hero.description}
            </p>

            <div className="flex flex-col sm:flex-row gap-4 pt-4">
              <button 
                onClick={scrollToPilot}
                className="px-8 py-4 rounded-lg text-white font-semibold flex items-center justify-center space-x-2 shadow-lg hover:opacity-90"
                style={{ backgroundColor: '#2D4A8F' }}
              >
                <span>{t.hero.ctaPrimary}</span>
                <ArrowRight size={20} />
              </button>
              <button 
                onClick={scrollToSolutions}
                className="px-8 py-4 rounded-lg font-semibold flex items-center justify-center space-x-2 border-2 bg-white hover:bg-gray-50"
                style={{ borderColor: '#2D4A8F', color: '#2D4A8F' }}
              >
                <Play size={20} />
                <span>{t.hero.ctaSecondary}</span>
              </button>
            </div>
          </div>

          {/* Right Content - Image Carousel */}
          <div className="relative">
            <div className="relative h-[500px] rounded-3xl overflow-hidden shadow-2xl">
              {heroCarouselImages.map((img, index) => (
                <img
                  key={index}
                  src={img}
                  alt={`Device ${index + 1}`}
                  className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-1000 ${
                    index === currentImageIndex ? 'opacity-100' : 'opacity-0'
                  }`}
                  style={{ borderRadius: '24px' }}
                />
              ))}
            </div>
            
            {/* Carousel Indicators */}
            <div className="flex justify-center space-x-2 mt-6">
              {heroCarouselImages.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setCurrentImageIndex(index)}
                  className={`h-2 rounded-full transition-all ${
                    index === currentImageIndex ? 'w-8 bg-[#2D4A8F]' : 'w-2 bg-gray-300'
                  }`}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;